"use client";

export function TypingIndicator() {
  return (
    <div role="status" aria-live="polite" className="flex h-8 items-center gap-1 px-1">
      <span className="sr-only">Assistant is thinking…</span>
      <div aria-hidden className="flex items-center gap-1">
        <span className="h-2 w-2 rounded-full bg-muted-foreground/40 animate-bounce [animation-delay:0ms]" />
        <span className="h-2 w-2 rounded-full bg-muted-foreground/40 animate-bounce [animation-delay:150ms]" />
        <span className="h-2 w-2 rounded-full bg-muted-foreground/40 animate-bounce [animation-delay:300ms]" />
      </div>
    </div>
  );
}
